import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector } from "react-redux";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { StylesProvider } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";

import Element from "../../components/Element/Element";
import Stepper from "../../ui/Stepper";
import FechaDespues from "../../components/FechaDespues";

import "../../components/Element/Element.css";
import "../../components/Screen.css";
import "../../ui/Stepper.css";

import ClipLoader from "react-spinners/ClipLoader";

import { decode } from "html-entities";

import { useTranslation } from "react-i18next";

import { motion } from "framer-motion";
import { containerVariants } from "../../animations/transitions";

//Tabs options for entre semana/fin de semana
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const Practicas = () => {
  const [t] = useTranslation("global");
  const [value, setValue] = useState(1); //Fin de semana tab is selected by default as a initial state value
  const [classes, setClasses] = useState("");
  const [indxNum, setIndxNum] = useState(0);

  const data = useSelector((state) => state.data.dataPracticas);
  const monthSelected = useSelector((state) => state.screens.monthSelected);
  const periodo = useSelector((state) => state.data.practicas.periodo);
  const disableClass = useSelector((state) => state.toggle.disable);
  const scrolldiv = useSelector((state) => state.screens.scrollDivPracticas);
  const isDataLoading = useSelector(
    (state) => state.data.isDataPracticasLoading
  );

  useEffect(() => {
    scrollTo();
  }, [monthSelected]);

  //Recover selected tab
  useEffect(() => {
    if (data[0]?.month.value.findesemana.length > 0) {
      //if an element of practicas (fecha de practicas) is already selected
      //check if it's on Entre Semana o Fin de semana
      //For example: if the user has choosen a date entre semana and moved to the next screen and wanted to go back
      //to practicas screen, the tab (entre semana or fin de semana) will be selected
      if (periodo === "" || periodo === "entre_semana") {
        setValue(0); //Select tab: entre semana
        scrollTo(); //Scroll to the element
      } else {
        setValue(1); //Select tab: fin de semana
        scrollTo();
      }
    }
  }, [periodo]);

  //url: https://reservas.escolaportbarcelona.com/ln/#entre_semana
  //check the # value and select it's tab
  //in this case Entre semana will be selected when loading the app
  useEffect(() => {
    let url = window.location.href;
    if (url.indexOf("#") !== -1) {
      let hash = url.split("#")[1];
      if (hash === "entre_semana") {
        setValue(0);
      }
    }

    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  //Scroll to element
  const scrollTo = () => {
    setTimeout(() => {
      //if the month is selected, scroll to the first element (div) of this month
      //otherwise scroll to selected element (div)
      let div = scrolldiv === "" ? `#${monthSelected}` : scrolldiv;

      if (scrolldiv || monthSelected) {
        const section = document.querySelector(div);

        if (scrolldiv === "#element_fechadespues") {
          window.scrollTo(0, 0);
        } else {
          section.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    }, 250);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //Get id of the selected element
  const handleClass = (value) => {
    setIndxNum(value);
    // if value > 0 - Como estaba antes
    if (value.length > 0) {
      setClasses(" element__disable");
    } else {
      setClasses("");
    }
  };

  if (isDataLoading) {
    return (
      <div className="screen__container">
        {/* Show loading icon */}
        <ClipLoader color="#499bb1" loading={true} size={100} />
      </div>
    );
  }

  return (
    <>
      <div className="fadeContainer">
        <StylesProvider injectFirst>
          <div className="stepper__container">
            <Stepper /> {/* 1-2-3-4 */}
            {data[0].month.id !== "" && (
              <div
                className={
                  disableClass
                    ? "screeen__modalidadContainer element__disable"
                    : "screeen__modalidadContainer"
                }
              >
                <AppBar position="static">
                  <Tabs
                    variant="fullWidth"
                    value={value}
                    onChange={handleChange}
                    aria-label="nav tabs example"
                  >
                    <LinkTab
                      label={t("PRACTICAS.labels.weekday")} //Entre semana
                      {...a11yProps(0)}
                    />
                    <LinkTab
                      label={t("PRACTICAS.labels.weekend")} //Fin de semana
                      {...a11yProps(1)}
                    />
                  </Tabs>
                </AppBar>
                <div className="screen__toolTipContainer arrow-top">
                  {t("PRACTICAS.tooltip")}{" "}
                  {/* Tooltip: Elige la modalidad de tus prácticas */}
                </div>
              </div>
            )}
          </div>
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <SwipeableViews
              axis={"x"}
              // fullWidth
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel value={value} index={0}>
                <div className="element__tab">
                  {/* Elegiré fecha después */}
                  <FechaDespues
                    id={-1}
                    screen="practicas"
                    handleClass={handleClass}
                    periodo="entre_semana"
                  />

                  {data.map((item) => {
                    return item.month.value.entresemana.map((itm) => {
                      if (itm !== null) {
                        if (itm.hasOwnProperty("id")) {
                          if (itm.id === indxNum) {
                            //Enable the selected element and disable the others
                            return (
                              <Element
                                key={itm.id}
                                month={item.month.name}
                                info={data}
                                data={{ itm }}
                                handleClass={handleClass}
                                classes=""
                                screen="practicas"
                                tipo="entre_semana"
                                modalidad={null}
                              />
                            );
                          } else {
                            return (
                              <Element
                                key={itm.id}
                                month={item.month.name}
                                info={data}
                                data={{ itm }}
                                handleClass={handleClass}
                                classes={classes}
                                screen="practicas"
                                tipo="entre_semana"
                              />
                            );
                          }
                        }
                      } else {
                        return (
                          // if there's no dates show this message:
                          // Estamos programando nuevas fechas, por supuesto que habrá prácticas entre semana.
                          <p
                            className={
                              disableClass
                                ? "screen__month element__disable"
                                : `screen__month`
                            }
                            id={item.month.name}
                          >
                            <span
                              style={{
                                textTransform: "capitalize",
                              }}
                            >
                              {" "}
                              {`${item.month.name}: `}{" "}
                            </span>
                            {`${decode(itm)}`}
                          </p>
                        );
                      }
                    });
                  })}
                </div>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <div className="element__tab">
                  <FechaDespues
                    id={-1}
                    screen="practicas"
                    handleClass={handleClass}
                    periodo="fin_desemana"
                  />

                  {data !== [] &&
                    data.map((item, idx) => {
                      return item.month.value.findesemana.map((itm) => {
                        if (itm !== null) {
                          if (itm.hasOwnProperty("id")) {
                            if (itm.id === indxNum) {
                              return (
                                <Element
                                  key={itm.id}
                                  month={item.month.name}
                                  info={data}
                                  data={{ itm }}
                                  handleClass={handleClass}
                                  classes=""
                                  screen="practicas"
                                  tipo="fin_semana"
                                />
                              );
                            } else {
                              return (
                                <Element
                                  key={itm.id}
                                  month={item.month.name}
                                  info={data}
                                  data={{ idx, itm }}
                                  handleClass={handleClass}
                                  classes={classes}
                                  screen="practicas"
                                  tipo="fin_semana"
                                />
                              );
                            }
                          }
                        } else {
                          return (
                            <p
                              className={
                                disableClass
                                  ? "screen__month element__disable"
                                  : `screen__month`
                              }
                              id={item.month.name}
                            >
                              <span> {`${item.month.name}: `} </span>
                              {`${decode(itm)}`}
                            </p>
                          );
                        }
                      });
                    })}
                </div>
              </TabPanel>
            </SwipeableViews>
          </motion.div>
        </StylesProvider>
      </div>
    </>
  );
};

export default Practicas;
